import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import PaycomReaderForm from '../forms/paycom-reader-form';
import { paycomReaderValidationSchema } from '../schema/paycomReader.js';

export default function PaycomReaderNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Paycom Reader Node Details',
        altText: 'Paycom Reader Node',
        defaultLabel: 'Paycom Reader Node',
      }}
    >
      <CommonNode FormComponent={PaycomReaderForm} schemaResolver={paycomReaderValidationSchema} />
    </NodeProvider>
  );
}
